import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { NavItemMaterial } from "../components/nav/NavItemMaterial";
import { SubNavItemMaterial } from "../components/nav/SubNavItemMaterial";
import ErrorAlert from "../components/ErrorAlert";
import ContrastToggle from "../containers/ContrastToggle";
import UnsupportedBrowser from "../containers/UnsupportedBrowser";
import Services from "../containers/Services";
import Messages from "../containers/Messages";
import MessageView from "../containers/MessageView";
import MessagesDelete from "../containers/MessagesDelete";
import History from "../containers/History";
import Settings from "../containers/Settings";
import About from "../containers/settings/About";
import ContactAddEdit from "../containers/ContactAddEdit";
import ContactInformation from "../containers/ContactInformation";
import ContactDelete from "../containers/ContactDelete";
import Contacts from "../containers/Contacts";
import Call from "../containers/Call";
import InCall from "../containers/InCall";
import FourOFour from "../containers/FourOFour";
import ChangeUser from "../containers/ChangeUser";
import ChangePassword from "../containers/ChangePassword";
import Log from "../containers/Log";
import Logout from "../containers/Logout";
import Footer from "../containers/Footer";
import { SIP_STATE } from "../reducers/sipReducer";
import logo from "../branding/current/logo.png";
import logoDark from "../branding/current/logo_dark.png";
import "./DefaultLayout.css";
import UserInformation from "../containers/UserInformation";
import { loadMessages } from "../actions/messageActions";
import { inIframe } from "../misc/inIframe";

function Username(props) {
  if (props.enabled) {
    return (
      <div className="username">
        <small>{props.username}</small> &nbsp;
      </div>
    );
  }
  return null;
}

function NavBar(props) {
  var activeServices = props.activeTabName === "services";
  var activeContacts = props.activeTabName === "contacts";
  var activeAccount = props.activeTabName === "userinformation";
  var activeSettings = props.activeTabName === "settings";
  var ariaText = props.text("aria.selected_page");
  var contactsSubMenuOpen =
    (activeServices || activeContacts) &&
    props.links.services.enabled &&
    props.links.contacts.enabled;
  var accountSubMenuOpen =
    (activeAccount || activeSettings) &&
    props.links.userinformation.enabled &&
    props.links.settings.enabled;
  var amountUnreadMessages = 0;
  var ua = window.navigator.userAgent;
  var browserIE =
    ua.indexOf("MSIE ") > 0 || ua.indexOf("Trident/") > 0 ? true : false;

  for (var i = 0; i < props.links.messages.messages.length; i++) {
    if (props.links.messages.messages[i].read === false) {
      amountUnreadMessages++;
    }
  }

  return (
    <div className="navbar navbar-expand-lg navbar-light no-transition">
      <header role="banner">
        <a
          className="navbar-logo nav-focus-border"
          href={props.text("login.loggedin.logo.href")}
        >
          <img
            className="logo"
            src={props.contrast ? logoDark : logo}
            alt={props.text("menu.logo")}
          />
        </a>
      </header>

      <nav className="navbar-toggler-nav">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="material-icons navbar-toggle-icon">dehaze</i>
        </button>
      </nav>

      <nav
        className={
          "collapse navbar-collapse navbar-tabs" + (browserIE ? " navIE" : "")
        }
        id="navbarSupportedContent"
        aria-label="Huvudmeny"
      >
        <ul className="navbar-nav" aria-label={props.text("aria.mainmenu")}>
          {props.links.services.enabled && !props.links.contacts.enabled && (
            <NavItemMaterial
              icon="view_comfy"
              text={props.links.services.text}
              ariaText={ariaText}
              route="services"
              chosen={activeServices ? true : false}
            />
          )}
          {!props.links.services.enabled && props.links.contacts.enabled && (
            <NavItemMaterial
              icon="contacts"
              text={props.links.contacts.text}
              ariaText={ariaText}
              route="contacts"
              chosen={activeContacts ? true : false}
            />
          )}
          {props.links.services.enabled && props.links.contacts.enabled && (
            <li className="nav-box">
              <ul className="no-ul-css">
                <NavItemMaterial
                  icon="contacts"
                  text={props.links.contacts.text}
                  ariaText={ariaText}
                  route="services"
                  chosen={activeServices || activeContacts ? true : false}
                />
                {contactsSubMenuOpen && (
                  <li>
                    <ul
                      className="navbar-nav navbar-sub navbar-sub-smallscreen"
                      aria-label={props.text("aria.submenu_contacts")}
                    >
                      <SubNavItemMaterial
                        text={props.links.services.text}
                        ariaText={ariaText}
                        route="services"
                        chosen={activeServices}
                      />
                      <SubNavItemMaterial
                        text={props.links.mycontacts.text}
                        ariaText={ariaText}
                        route="contacts"
                        chosen={activeContacts}
                      />
                    </ul>
                  </li>
                )}
              </ul>
            </li>
          )}

          {props.links.call.enabled && (
            <NavItemMaterial
              icon="dialpad"
              text={props.links.call.text}
              ariaText={ariaText}
              route="call"
              chosen={props.activeTabName === "call" ? true : false}
            />
          )}
          {props.links.history.enabled && (
            <NavItemMaterial
              icon="history"
              text={props.links.history.text}
              ariaText={ariaText}
              route="history"
              chosen={props.activeTabName === "history" ? true : false}
            />
          )}
          {props.links.messages.enabled && (
            <NavItemMaterial
              icon="message"
              text={props.links.messages.text}
              ariaText={ariaText}
              route="messages"
              chosen={props.activeTabName === "messages" ? true : false}
              amountUnreadMessages={amountUnreadMessages}
            />
          )}

          {props.links.userinformation.enabled &&
            !props.links.settings.enabled && (
              <NavItemMaterial
                icon="account_box"
                text={props.links.userinformation.text}
                ariaText={ariaText}
                route="userinformation"
                chosen={activeAccount ? true : false}
              />
            )}
          {!props.links.userinformation.enabled &&
            props.links.settings.enabled && (
              <NavItemMaterial
                icon="settings"
                text={props.links.settings.text}
                ariaText={ariaText}
                route="settings"
                chosen={activeSettings ? true : false}
              />
            )}
          {props.links.userinformation.enabled &&
            props.links.settings.enabled &&
            props.settingsInMenu && (
              <li className="nav-box">
                <ul className="no-ul-css">
                  <NavItemMaterial
                    icon="settings"
                    text={props.links.settings.text}
                    ariaText={ariaText}
                    route="settings"
                    chosen={activeAccount || activeSettings ? true : false}
                  />
                </ul>
              </li>
            )}
          {props.links.userinformation.enabled &&
            props.links.settings.enabled &&
            !props.settingsInMenu && (
              <li className="nav-box">
                <ul className="no-ul-css">
                  <NavItemMaterial
                    icon="account_box"
                    text={props.links.userinformation.text}
                    ariaText={ariaText}
                    route="userinformation"
                    chosen={activeAccount || activeSettings ? true : false}
                  />
                </ul>
              </li>
            )}

          <ContrastToggle />
          {props.logout && <Logout />}
          {props.links.debug.enabled && (
            <NavItemMaterial
              icon="format_align_justify"
              text={props.links.debug.text}
              ariaText={ariaText}
              route="log"
              chosen={props.activeTabName === "log" ? true : false}
            />
          )}
        </ul>

        {contactsSubMenuOpen && (
          <ul
            className="navbar-nav navbar-sub navbar-sub-bigscreen"
            aria-label={props.text("aria.submenu_contacts")}
          >
            <SubNavItemMaterial
              text={props.links.services.text}
              ariaText={ariaText}
              route="services"
              chosen={activeServices}
            />
            <SubNavItemMaterial
              text={props.links.mycontacts.text}
              ariaText={ariaText}
              route="contacts"
              chosen={activeContacts}
            />
          </ul>
        )}
        {accountSubMenuOpen && props.settingsInMenu && (
          <ul
            className="navbar-nav navbar-sub navbar-sub-bigscreen"
            aria-label={props.text("aria.submenu_account")}
          >
            <SubNavItemMaterial
              text={props.links.settings.text}
              ariaText={ariaText}
              route="settings"
              chosen={activeSettings}
            />
            <SubNavItemMaterial
              text={props.links.userprofile.text}
              ariaText={ariaText}
              route="userinformation"
              chosen={activeAccount}
            />
          </ul>
        )}
        {accountSubMenuOpen && !props.settingsInMenu && (
          <ul
            className="navbar-nav navbar-sub navbar-sub-bigscreen"
            aria-label={props.text("aria.submenu_account")}
          >
            <SubNavItemMaterial
              text={props.links.userprofile.text}
              ariaText={ariaText}
              route="userinformation"
              chosen={activeAccount}
            />
            <SubNavItemMaterial
              text={props.links.settings.text}
              ariaText={ariaText}
              route="settings"
              chosen={activeSettings}
            />
          </ul>
        )}
      </nav>
    </div>
  );
}

const NoMatch = () => <Redirect to={{ pathname: "/" }} />;

class DefaultLayout extends React.Component {
  componentDidMount() {
    this.props.loadMessages();
  }

  getDefaultComponent() {
    switch (this.props.home) {
      case "services":
        return Services;
      case "call":
        return Call;
      case "contacts":
        return Contacts;
      case "history":
        return History;
      case "messages":
        return Messages;
      default:
        return Services;
    }
  }

  render() {
    if (
      this.props.kiosk ||
      (!this.props.inIframe && inIframe()) ||
      (this.props.forceIframe && !inIframe())
    ) {
      return <FourOFour />;
    }
    if (this.props.sipState === SIP_STATE.IN_CALL) {
      return <InCall />;
    }

    var pagename;
    if (this.props.location.pathname !== undefined) {
      if (this.props.location.pathname === "/") {
        pagename = this.props.home;
      } else {
        pagename = this.props.location.pathname.split("/")[1];
      }
      document.title = this.props.text("titles." + pagename);
    }

    var offlineText =
      this.props.serverError || this.props.freeswitchError
        ? this.props.text("network.networkError")
        : !this.props.isSipOnline && this.props.isOnlineEnabled
        ? this.props.text("network.offline")
        : this.props.sipError
        ? this.props.sipErrorMessage
        : "No error";

    var nocontainer = pagename === "settings" ? true : false;

    var activeContacts = pagename === "services" || pagename === "contacts";
    var activeAccount =
      pagename === "userinformation" || pagename === "settings";
    var footerVisible = ["services", "call"].indexOf(pagename) > -1;
    var contactsSubMenuOpen =
      activeContacts &&
      this.props.links.services.enabled &&
      this.props.links.contacts.enabled;
    var accountSubMenuOpen =
      activeAccount &&
      this.props.links.userinformation.enabled &&
      this.props.links.settings.enabled;
    var navSubMenuOpen = contactsSubMenuOpen || accountSubMenuOpen;
    var showErrorAlert =
      this.props.serverError ||
      this.props.freeswitchError ||
      this.props.sipError ||
      (!this.props.isSipOnline && this.props.isOnlineEnabled);

    nocontainer = this.props.unsupportedBrowser ? false : nocontainer;

    const defaultComponent = this.getDefaultComponent();
    return (
      <div>
        <div className="branding-header">
          <Username
            enabled={this.props.isNameEnabled}
            username={this.props.username}
          />
          <NavBar
            links={this.props.links}
            text={this.props.text}
            activeTabName={pagename}
            contrast={this.props.contrast}
            settingsInMenu={this.props.settingsInMenu}
            logout={this.props.isLogoutLinkEnabled}
          />
        </div>

        <main
          className={
            (nocontainer ? "" : "main-container margin-sub") +
            (footerVisible ? " footer-visible" : "")
          }
          role="main"
        >
          {showErrorAlert && nocontainer === false && (
            <ErrorAlert text={offlineText} />
          )}

          {this.props.unsupportedBrowser ? (
            <Switch>
              <Route component={UnsupportedBrowser} />
            </Switch>
          ) : (
            <Switch>
              <Route path="/services" component={Services} />
              <Route
                path="/contacts/edit/:id"
                render={props => <ContactAddEdit {...props} mode="edit" />}
              />
              <Route
                path="/contacts/information/:id"
                render={props => (
                  <ContactInformation {...props} mode="information" />
                )}
              />
              <Route
                path="/contacts/delete/:id"
                render={props => <ContactDelete {...props} />}
              />
              <Route
                path="/contacts/add"
                render={props => <ContactAddEdit {...props} mode="add" />}
              />
              <Route path="/contacts" component={Contacts} />
              <Route path="/history" component={History} />
              <Route
                path="/settings/:settingFor/:settingForFor"
                render={() => (
                  <Settings
                    navSubMenuOpen={navSubMenuOpen}
                    showErrorAlert={showErrorAlert}
                    offlineText={offlineText}
                  />
                )}
              />
              <Route
                path="/settings/:settingFor"
                render={() => (
                  <Settings
                    navSubMenuOpen={navSubMenuOpen}
                    showErrorAlert={showErrorAlert}
                    offlineText={offlineText}
                  />
                )}
              />
              <Route
                path="/settings"
                render={() => (
                  <Settings
                    navSubMenuOpen={navSubMenuOpen}
                    showErrorAlert={showErrorAlert}
                    offlineText={offlineText}
                  />
                )}
              />
              <Route path="/call" component={Call} />
              <Route
                path="/messages/view/:messageNumber"
                component={MessageView}
              />
              <Route path="/messages/delete" component={MessagesDelete} />
              <Route path="/messages" component={Messages} />
              <Route path="/userinformation/edit" component={ChangeUser} />
              <Route
                path="/userinformation/changePassword"
                component={ChangePassword}
              />
              <Route path="/userinformation" component={UserInformation} />
              <Route path="/log" component={Log} />
              <Route path="/about" component={About} />
              <Route exact path="/" component={defaultComponent} />
              <Route component={NoMatch} />
            </Switch>
          )}
        </main>
        <Switch>
          <Route path="/services" component={Footer} />
          <Route exact path="/" component={Footer} />
          <Route path="/call" component={Footer} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    links: {
      services: {
        enabled: state.config.mode.services_enabled,
        text: state.config.text("menu.services"),
      },
      contacts: {
        enabled: state.config.mode.contacts_enabled,
        text: state.config.text("menu.contacts"),
      },
      mycontacts: {
        text: state.config.text("menu.mycontacts"),
      },
      call: {
        enabled: state.config.mode.call_enabled,
        text: state.config.text("menu.call"),
      },
      history: {
        enabled: state.config.mode.history_enabled,
        text: state.config.text("menu.history"),
      },
      messages: {
        enabled: state.config.mode.messages_enabled,
        text: state.config.text("menu.messages"),
        messages: state.message.messages,
      },
      settings: {
        enabled: state.config.mode.settings_enabled,
        text: state.config.text("menu.settings"),
      },
      online: {
        enabled: state.config.mode.online_enabled,
        text: state.config.text("common.online"),
      },
      debug: {
        enabled:
          state.config.mode.debug_enabled_in_menu === true &&
          state.config.mode.debug_enabled === true,
        text: state.config.text("menu.log"),
      },
      userinformation: {
        enabled:
          state.config.mode.changeuser_enabled && state.user.anonymous === false
            ? true
            : false,
        text: state.config.text("menu.userinformation"),
      },
      userprofile: {
        text: state.config.text("menu.userprofile"),
      },
    },
    contrast: state.accessibility.isHighContrast,
    authenticated: state.user.authenticated,
    username: state.user.username,
    text: state.config.text,
    isSipOnline: state.sip.online,
    kiosk: state.config.mode.kiosk,
    inIframe: state.config.mode.inIframe,
    forceIframe: state.config.mode.forceIframe,
    isOnlineEnabled: state.config.mode.online_enabled,
    isLogoutLinkEnabled: state.config.mode.logout_enabled,
    settingsInMenu: state.config.mode.display_settings_in_menu,
    isNameEnabled: false,
    home: state.config.mode.home,
    sipState: state.sip.sipState,
    serverError: state.network.serverError,
    freeswitchError: state.network.freeswitchError,
    sipError: state.network.sipError,
    sipErrorMessage: state.network.sipErrorMessage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadMessages: () => {
      return dispatch(loadMessages());
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLayout)
);






// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout.js